document.addEventListener('DOMContentLoaded', () => {
  const tabContainer = document.querySelector('.tab-header');
  const links = [...document.querySelectorAll('.tab-handle')];
  const sections = [...document.querySelectorAll('.collection-products-section')];

  const headerOffset = 100;
  let ticking = false;
  let activeSection;

  function setActiveSection(section) {
    if (!section || section === activeSection) return;

    activeSection = section;

    links.forEach((link) => {
      const isActive =
        link.getAttribute('href') === `#${section.id}`;

      link.classList.toggle('active', isActive);

      if (isActive) {
        link.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    });
  }

  function updateActiveTab() {
    if (!sections.length) return;

    const scrollPosition = window.scrollY + headerOffset + 1;
    const documentBottom = window.scrollY + window.innerHeight;
    const pageBottom = document.documentElement.scrollHeight;

    // Activate the final tab when the bottom of the page is reached.
    if (documentBottom >= pageBottom - 2) {
      setActiveSection(sections[sections.length - 1]);
      return;
    }

    let currentSection = sections[0];

    sections.forEach((section) => {
      const sectionTop =
        section.getBoundingClientRect().top + window.scrollY;

      if (sectionTop <= scrollPosition) {
        currentSection = section;
      }
    });

    setActiveSection(currentSection);
  }

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;

      window.requestAnimationFrame(() => {
        updateActiveTab();
        ticking = false;
      });

      ticking = true;
    },
    { passive: true }
  );

  window.addEventListener('resize', updateActiveTab);

  updateActiveTab();
});

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.tab-header');
  el.addEventListener('dragstart', e => e.preventDefault());

  let down = false;
  let startX;
  let startScroll;

  el.addEventListener('mousedown', (e) => {
    down = true;
    startX = e.pageX;
    startScroll = el.scrollLeft;
    el.classList.add('dragging');
  });

  el.addEventListener('mouseup', () => {
    down = false;
    el.classList.remove('dragging');
  });

  el.addEventListener('mouseleave', () => {
    down = false;
    el.classList.remove('dragging');
  });

  el.addEventListener('mousemove', (e) => {
    if (!down) return;

    e.preventDefault();
    el.scrollLeft = startScroll - (e.pageX - startX);
  });
});
